import React from "react";
import { Button, Stack } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import ReferenceBuilder from "./ReferenceBuilder";
import { AssemblyType } from "../types/assembly-model";
import { AssemblyReferenceWriteModel } from "../types/assembly-reference";

interface AddReferenceViewProps {
  assemblyType: AssemblyType;
  assignedGroupObjectIdentifier?: string;
  onBack: () => void;
  onSubmit: (model: AssemblyReferenceWriteModel, promptLabel: string) => Promise<void>;
  loading: boolean;
  error: boolean;
}

const AddReferenceView = ({
  assemblyType,
  assignedGroupObjectIdentifier,
  onBack,
  onSubmit,
  loading,
  error,
}: AddReferenceViewProps) => {
  return (
    <Stack spacing={2} direction="column" p={2}>
      <Stack direction="row" alignItems="center">
        <Button
          startIcon={<ArrowBack fontSize="small" />}
          variant="text"
          sx={{ color: "text.secondary" }}
          onClick={onBack}
          size="small"
        >
          Back
        </Button>
      </Stack>
      <ReferenceBuilder
        assemblyType={assemblyType}
        assignedGroupObjectIdentifier={assignedGroupObjectIdentifier}
        onSubmit={onSubmit}
        loading={loading}
        error={error}
        onClose={onBack}
      />
    </Stack>
  );
};

export default AddReferenceView;
